import { Color, getThemeColor } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { Label, Panel, Textbox } from "@mcleod/components";
import { AutogenLayoutCarrierQualification } from "./autogen/AutogenLayoutCarrierQualification";

interface ValidationData {
    passed: boolean;
    warning: boolean;
    message: string;
    profile_id: string;
    details: {
        points: number;
        descr: string;
    }[];
    failed_items: string[];
}

export class CarrierQualification extends AutogenLayoutCarrierQualification {
    setQualificationData(carrierValidationData: ValidationData) {
        this.panelResults.removeAll();
        if (carrierValidationData != null) {
            const qualified = carrierValidationData.passed && !carrierValidationData.warning;
            const warning = carrierValidationData.warning;
            const color = qualified ? getThemeColor("success") : warning ? getThemeColor("warning") : getThemeColor("error");

            const detailPanel = new Panel({ fillRow: true });
            detailPanel.add(new Label({
                text: carrierValidationData.message, color: color,
                imageName: qualified ? this.getSuccessImageName(carrierValidationData.warning) : ImageName.circleError,
                fontSize: "large",
                fontBold: true
            }));

            this.performOnDetails(carrierValidationData.details, detailPanel, qualified);

            this.panelResults.add(detailPanel);
            this.panelResults.borderColor = color;
            this.textboxProfile.text = carrierValidationData.profile_id;
            this.panelResults.visible = true;
            this.textboxProfile.visible = true;
            this.panelResults.tooltipDynamicContent = () => { return this.setQualificationTooltipContent(carrierValidationData.details, qualified, color, carrierValidationData) };
        }
    }

    getSuccessImageName(warning: boolean): ImageName {
        if (warning) {
            return ImageName.triangleWarning;
        }
        return ImageName.circleCheck
    }

    private setQualificationTooltipContent(details: any, success: boolean, color: Color,
        carrierValidationData: ValidationData): Panel {
        const panel = new Panel({ padding: 0, margin: 0 });
        panel.add(new Label({ text: "Qualifications", fontSize: "large", fontBold: true }));
        panel.add(new Textbox({printable: true, caption: "Qualification Profile", enabled: this.enabled, width: undefined, field: "text_value", text: carrierValidationData.profile_id}));
        panel.add(new Label({
            text: carrierValidationData.message, color: color,
            imageName: success ? this.getSuccessImageName(carrierValidationData.warning) : ImageName.circleError,
            fontSize: "large",
            fontBold: true
        }));

        this.performOnDetails(details, panel, success);
        return panel;
    }

    clearQualificationData() {
        this.panelResults.removeAll();
        this.panelResults.visible = false;
        this.textboxProfile.visible = false;
    }

    performOnDetails(details: any, Panel: Panel, success) {
        details?.forEach(detail => {
            if ((success && detail.points == 0) || (!success && detail.points > 0))
                Panel.add(new Label({ text: detail.descr, fontSize: "medium", marginLeft: 35, fontBold: true }));
        });
    }
}
